import React from 'react';
import { Alert, Glyphicon } from 'react-bootstrap';

const FileStatusInfo = () => {
  return (
    <Alert bsStyle="info">
      <Glyphicon glyph="ok" /> — Approved<br />
      <Glyphicon glyph="hourglass" /> — Pending<br />
      <Glyphicon glyph="remove" /> — Rejected
    </Alert>
  );
};

export default FileStatusInfo;



// WEBPACK FOOTER //
// ./src/components/FileStatusInfo.js